import { mapModel } from '../../api';
import {
  MAP_EVENTS,
  sendMapApiEvents,
} from '../../helpers/analytics/map.analytics';

export const SET_MAP_DATA = 'SET_MAP_DATA';
export const SET_ORDER_RUN_DATA = 'SET_ORDER_RUN_DATA';

export const setMapData = (mapData) => ({
  type: SET_MAP_DATA,
  mapData,
});

export const setOrderRunData = (orderRunData) => ({
  type: SET_ORDER_RUN_DATA,
  orderRunData,
});

export const getOrderTrackData = (params) => (dispatch, getState) => {
  const { mapState } = getState();
  const { mapData } = mapState;
  let mapObj = mapData;
  const orderId = params['order_id'];
  const userId = params['user_id'];
  return mapModel
    .getOrderTrackData(params)
    .then((response) => {
      if (!response || response?.isError) return response;
      sendMapApiEvents(MAP_EVENTS.GET_MAP_DETAILS_SUCCESS, orderId, userId);
      mapObj[orderId] = response;
      dispatch(setMapData(mapObj));
      return response;
    })
    .catch((err) => {
      sendMapApiEvents(MAP_EVENTS.GET_MAP_DETAILS_FAILURE, orderId, userId);
      return err;
    });
};

export const getOrderRunData = (params) => (dispatch, getState) => {
  const { mapState } = getState();
  const { orderRunData } = mapState;
  let mapObj = orderRunData;
  const orderId = params['order_id'];
  const userId = params['user_id'];
  return mapModel
    .getOrderRunData({ order_id: orderId })
    .then((response) => {
      if (!response || response?.isError) return response;
      sendMapApiEvents(MAP_EVENTS.GET_MAP_DETAILS_SUCCESS, orderId, userId);
      mapObj[orderId] = response;
      dispatch(setOrderRunData(mapObj));
      return response;
    })
    .catch((err) => {
      sendMapApiEvents(MAP_EVENTS.GET_MAP_DETAILS_FAILURE, orderId, userId);
      return err;
    });
};
